import { MAX_FILE_SIZE, SUPPORTED_FILE_EXTENSIONS } from './constants'

export const checkFileProperties = ({ name, size }: File) => {
  const fileExtension = name.replace(/^.*\./, '')
  return (
    size < MAX_FILE_SIZE &&
    SUPPORTED_FILE_EXTENSIONS.includes(fileExtension.toLowerCase())
  )
}
